import React, { useContext, useEffect, useState } from "react";
// styled components
import { Row, Col, Empty, Table, Button, Modal } from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// icons
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useSubsanarBeps } from "../../../hooks/useSubsanarBeps";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../components/BannerPanel";
import { MenuUsuario } from "../components/MenuUsuario";
import { Footer } from "../../../components/Landing/Footer";
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import { ModalAceptar } from "../components/ModalAceptar";
import apiRolesPermisos from "../../../api/Roles/api-roles-permisos";
import apiNotificaciones from "../../../api/Notificaciones/api-notificaciones";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { TemplateContext } from "../../../utils/template_context";
import getStorageUser from "../../../middlewares/GetStorageUser"

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};
export const SubsanarBeps = () => {
  const {
    documentossubsanar,
    setDocumentosSubsanar,
    // totaldocumentossubsanar,
    cantidadpáginassubsanar,
    cambiarCantidadPaginasDocumentos,
    cargarPostulaciones,
    guardarArchivosAdministrativos,
    // postulacionesBeps,
    setPostulacionState,
    cambiarEstadoPostulaciónDocumentos,
  } = useSubsanarBeps();
  const context = useContext(TemplateContext);
  // console.log(documentossubsanar, 'acá')
  const [modaldocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const [tipodocumento, setTipodocumento] = useState<string>("");
  const [indexdocumento, setIndexDocumento] = useState<number>(0);
  const [evento, setEvento] = useState<any>({});
  const [datosdocumento, setDatosDocumento] = useState<any>({});
  const [nombredocumento, setNombreDocumento] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [observaciones, setObservaciones] = useState<string>("");
  const [aceptarmodaldocumento, setAceptarModalDocumento] =
    useState<boolean>(false);
  useEffect(() => {
    cargarPostulaciones();
  }, []);
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const AceptarModalDocumento = async () => {
    try {
      const resp = await guardarArchivosAdministrativos(
        datosdocumento,
        evento,
        indexdocumento
      );
      const user = getStorageUser()
      const { data } = await apiParticipantes.consultarPostulacion(
        datosdocumento.id_postulacion
      );
      let notificacionCorreo = {
        tipo_participante: 3,
        tipo_notificacion: "Subsanación",
        remitente: user.documento,
        convocatoria_id: data.convocatoria_id,
      };
      await apiNotificaciones.enviarNotificacion(notificacionCorreo);
      return setAceptarModalDocumento(false);
      // documentossubsanar[indexdocumento].estado = "Subsanado";
      // const resp1 = await cambiarEstadoPostulaciónDocumentos();
      // console.log(resp)
      // console.log(resp1)
    } catch (error) {
      console.log(error);
    }
  };
  const CancelarModalDocumento = () => {
    return setAceptarModalDocumento(false);
  };
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  }
  const subsanar = async (e: any, datos: any, index: any) => {
    if (e.target.files!.length > 0) {
      const { name } = e.target.files![0];
      setTipodocumento(datos.descripcion);
      setNombreDocumento(name);
      setDatosDocumento(datos);
      setEvento(e);
      // console.log(documentossubsanar[index], 'es este papu')
      setPostulacionState(documentossubsanar[index]);
      await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: Number(datos.id_postulacion), estado: "Subsanado" });
      return setAceptarModalDocumento(true);
    }
    e.target.value = "";
  };
  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Documento",
      width: 100,
      dataIndex: "tipo_documento",
      key: "tipo_documento",
      // render: (datos: any, datos2: any, index: number) => {
      //     return (
      //         <>
      //             <span>{index + 1}</span>
      //         </>
      //     );
      // },
    },
    {
      title: "Estado",
      width: 100,
      dataIndex: "estado",
      key: "estado",
      render: (datos: any) => {
        console.log(datos, "datos del render");
        return (
          <>
            <span style={{ color: coloresEstado[datos] }}>{datos}</span>
          </>
        );
      },
    },
    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">Acciones</div>
        </div>
      ),
      width: 50,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, datos2: any, index: number) => (
        <>
          <div className="row">
            <div className=" col-12 justify-content-center">
              <Button
                // onClick={() => VerPropuesta(datos)}
                onClick={() => {
                  setModalDocumento(true);
                  setDocumento(datos.url_participante);
                }}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                VER
              </Button>
              <Button
                onClick={async () => { 
                  const postulacion = await apiParticipantes.obtenerObservacionBeps(datos.id_postulacion);
                  setObservaciones(postulacion.data[0].observaciones);
                  showModal() 
                }}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                OBSERVACIÓN
              </Button>
              <Button
                // onClick={() => VerPropuesta(datos)}
                onClick={() => {
                  var inputs: HTMLElement = document.getElementsByClassName(
                    "inputs-ref-subsanable-mis-postulaciones"
                  )[index] as HTMLElement;
                  inputs.click();
                  return setIndexDocumento(index);
                }}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                SUBSANAR
              </Button>
              <input
                className="inputs-ref-subsanable-mis-postulaciones"
                type="file"
                hidden
                onChange={(e) => {
                  subsanar(e, datos, index);
                }}
              />
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      <Header />
      <BannerPanel />
      <div
        className="container-fluid2"
        style={{ paddingTop: "16px", paddingBottom: "5%" }}
      >
        <div className="row">
          <MenuUsuario activeItem={2} />
          <div className="col col-12 col-md-12 col-lg-10">
            <div className="row">
              <div className="justify-content-center">
                <div className="container-titulo-usuario-logeado">
                  <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
                    <span className="font-family-Montserrat-Bold">
                      Subsanar documentos
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12 font-family-Montserrat-Regular font-size-14px">
                {" "}
                <span className="font-family-Montserrat-SemiBold">
                  Si tienes documentos pendientes por subsanar,
                </span>{" "}
                usa la acción "Ver más" y "Subsanar documento" para cargar un
                nuevo archivo y enviarlo a revisión.
              </div>
              <div className="col-12">
                <div
                  className="row-shadow"
                  style={{ marginBottom: "16px", marginTop: "16px" }}
                >
                  <div className="row">
                    <div className="col-12 col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
                      Gestionar postulación de proyectos
                    </div>
                    <div className="col-12 col-md-6 pb-2">
                      <div className="row g-2">
                        <div className="col-10 col-md-10  col-xl-10 col-xxl-11 d-flex justify-content-end align-content-center">
                          <span className="pe-4 col d-flex justify-content-md-end">
                            Total :{" "}
                            <span className="font-color-F28C02">
                              {/* {totaldocumentossubsanar} */}
                            </span>
                          </span>
                          <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                            Registros por página
                          </span>
                        </div>
                        <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                          <Dropdown
                            fluid
                            className="select-registros-adminconvocatoria no-margin"
                            defaultValue={cantidadpáginassubsanar}
                            options={cantidadRegistros}
                            icon={
                              <Icon
                                className="font-color-051923bf iconos-dropdown-global"
                                name="angle down"
                              />
                            }
                            onChange={(e, { value }) =>
                              cambiarCantidadPaginasDocumentos(e, value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-12">
                      <Table
                        style={{ borderTop: "1px solid #C4C4C4" }}
                        locale={{
                          emptyText: (
                            <Empty
                              description="No se han diligenciados datos para está sección"
                              style={{ padding: "50px" }}
                            />
                          ),
                        }}
                        pagination={{
                          position: ["bottomRight"],
                          itemRender: itemRenderTable,
                          pageSize: cantidadpáginassubsanar,
                        }}
                        columns={columns}
                        dataSource={documentossubsanar}
                        scroll={{ x: 1500, y: 300 }}
                        size="small"
                        rowClassName="sizeTable table-row"
                        className="table-ant-design-modify"
                        bordered={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ModalVisualizarDocumentos
        visualizar={modaldocumento}
        setVisualizar={setModalDocumento}
        state={{ documento: documento }}
        tipo="participante"
      />
      <ModalAceptar
        modal={aceptarmodaldocumento}
        AceptarModal={AceptarModalDocumento}
        CancelarArchivo={CancelarModalDocumento}
        CancelarModal={() => setAceptarModalDocumento(false)}
        TipoDocumento={tipodocumento}
        NombreArchivo={nombredocumento}
      />
      <Modal
        style={{ top: 60, zIndex: 3, background: "transparent" }}
        visible={isModalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        closeIcon="X"
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        maskStyle={{
          zIndex: 3,
          background: "rgba(0,144,76,0.8)",
        }}
        className="modal-postulacion-exitosa modal-formularios-completar"
      >
        <div>
          <div className="row-shadow">
            <div className="row">
              <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                Tienes las siguientes observaciones:
                <br />
              </div>
              <div className="text-center p-3 col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                { observaciones }
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
